import { useState, useEffect, useMemo } from "react";
import { Calendar, ChevronLeft } from "lucide-react";
import { TeamLogo } from "../shared/TeamLogo";
import { calculateGameStats } from "../../utils/gameUtils";

export const GameHeader = ({ gameData, onBack }) => {
    const [windowWidth, setWindowWidth] = useState(typeof window !== "undefined" ? window.innerWidth : 1200);
    useEffect(() => {
      const onResize = () => setWindowWidth(window.innerWidth);
      window.addEventListener("resize", onResize);
      return () => window.removeEventListener("resize", onResize);
    }, []);
    const formattedDate = useMemo(() => {
      const raw = gameData.game_date;
      let d;
      if (typeof raw === "string" && /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.test(raw)) {
        const [, mm, dd, yyyy] = raw.match(/(\d{1,2})\/(\d{1,2})\/(\d{4})/);
        d = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
      } else {
        d = new Date(raw);
      }
      if (Number.isNaN(d.getTime())) return String(raw || "");
      if (windowWidth < 640) return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
      return d.toLocaleDateString(undefined, { weekday: "long", month: "long", day: "numeric", year: "numeric" });
    }, [gameData.game_date, windowWidth]);
    const stats = calculateGameStats(gameData);
    if (!stats) return null;
    return (
      <div className="bg-white p-3 sm:p-4 md:p-6 rounded-xl shadow-sm border border-gray-200 mb-6">
        <div className="flex items-center justify-between">
          <button onClick={onBack} className="hover:text-gray-900 text-gray-500 transition-colors rounded-full p-1 hover:bg-gray-50 group" aria-label="Back to scoreboard">
            <ChevronLeft className="w-4 h-4 sm:w-5 sm:h-5 group-hover:-translate-x-0.5 transition-transform" />
          </button>
          <div className="flex items-center gap-2 text-gray-600">
            <Calendar className="w-4 h-4" />
            <span className="text-xs sm:text-sm">{formattedDate}</span>
          </div>
          <div className="w-16" />
        </div>
  
        <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 items-center">
          <div className="flex items-center sm:justify-start justify-center gap-3">
            <TeamLogo teamId={gameData.away_team_id} teamName={gameData.away_team} />
            <div className="min-w-0">
              <div className="text-sm font-medium text-gray-800 truncate">{gameData.away_team}</div>
            </div>
          </div>
          <div className="flex items-center justify-center mt-3 sm:mt-0">
            <div className="text-2xl sm:text-3xl font-bold text-gray-900">
              {stats.awayScore}
              <span className="mx-2 text-gray-400">-</span>
              {stats.homeScore}
            </div>
          </div>
          <div className="flex items-center sm:justify-end justify-center gap-3 mt-3 sm:mt-0">
            <div className="min-w-0 text-right">
              <div className="text-sm font-medium text-gray-800 truncate">{gameData.home_team}</div>
            </div>
            <TeamLogo teamId={gameData.home_team_id} teamName={gameData.home_team} />
          </div>
        </div>
      </div>
    );
  };
